"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var UWPStorage = (function () {
    function UWPStorage(context, winRtBridge, appName) {
        this.context = context;
        this.winRtBridge = winRtBridge;
        this.appName = appName;
        this.passwordVault = winRtBridge.instantiatePasswordVault();
    }
    UWPStorage.prototype.setItem = function (key, value) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.setItem(key, value); });
    };
    UWPStorage.prototype.getItem = function (key) {
        try {
            var storageValue = this.context.localStorage.getItem(key);
            return Promise.resolve(storageValue);
        }
        catch (e) {
            return Promise.reject(e);
        }
    };
    UWPStorage.prototype.removeItem = function (key) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.removeItem(key); });
    };
    UWPStorage.prototype.setSecureItem = function (key, value) {
        var _this = this;
        var setItem = function () {
            var credential = _this.winRtBridge.createPasswordCredential(_this.appName, key, value);
            _this.passwordVault.add(credential);
        };
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(setItem);
    };
    UWPStorage.prototype.getSecureItem = function (key) {
        try {
            var credential = this.tryGetCredential(this.appName, key);
            return Promise.resolve(credential ? credential.password : null);
        }
        catch (e) {
            return Promise.reject(e);
        }
    };
    UWPStorage.prototype.removeSecureItem = function (key) {
        var _this = this;
        var removeItem = function () {
            var credential = _this.tryGetCredential(_this.appName, key);
            if (credential) {
                _this.passwordVault.remove(credential);
            }
        };
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(removeItem);
    };
    UWPStorage.prototype.clear = function () {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.clear(); });
    };
    UWPStorage.prototype.tryGetCredential = function (resource, username) {
        try {
            var credential = this.passwordVault.retrieve(resource, username);
            credential.retrievePassword();
            return credential;
        }
        catch (e) {
            return null;
        }
    };
    return UWPStorage;
}());
exports.UWPStorage = UWPStorage;
